import React from "react";

import ClassesPage from "../../components/pages/Classes";
import Forbidden from "../../components/pages/Forbidden";
import { SideMenu } from "../../components/utils/SideMenu/SideMenu.container";
import { SideMenuArrowContext, SideMenuCloseArrow } from "../../components/utils/SideMenu/SideMenuCloseArrow";
import Spinner from "../../components/utils/Spinner";
import SubTopbar from "../../components/utils/SubTopbar";
import TopBar from "../../components/utils/TopBar";
import { IClassesProps, IClassesState } from "./types";

export class ClassesComponent extends React.Component<IClassesProps, IClassesState> {
  public static contextType = SideMenuArrowContext;
  constructor(props: IClassesProps, context: {}) {
    super(props, context);
    this.state = {
      menuExpanded: false,
    };
  }

  public componentDidMount() {
    this.props.mount();
  }

  public componentWillUnmount() {
    this.props.unmount();
  }

  public render() {
    const { accountId, organizationName, userName, classes, deleteClass, isAuthenticated, isLoading } = this.props;
    const { isOpen } = this.context;
    if (isLoading) {
      return <Spinner />;
    }
    if (!isAuthenticated) {
      return <Forbidden />;
    }
    return (
      <>
        <TopBar showToggleMenu={true} onToggleMenuClick={this.onToggleMenuClick} userName={userName} />
        <SideMenuCloseArrow />
        <SideMenu
          expanded={this.state.menuExpanded}
          organizationName={organizationName}
          userName={userName}
          onClose={this.onToggleMenuClick}
          isOpen={isOpen}
        />
        <SubTopbar withSidebar={true} isOpen={isOpen}>
          <ClassesPage
            accountId={accountId}
            addNewClass={this.props.addNewClass}
            classes={classes}
            deleteClass={deleteClass}
          />
        </SubTopbar>
      </>
    );
  }

  public onToggleMenuClick = () => {
    this.setState({ menuExpanded: !this.state.menuExpanded });
  };
}
